import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { menus } from '@core/components/core-menu/core-menu.component';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { AuthService, _isAuthenticated, _isRole } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private jwtHelper: JwtHelperService,
    private router: Router,
    private _toastService: ToastrService,
    private authServic: AuthService,
    private _coreMenuService: CoreMenuService,

  ) {
    //authServic.identityCheck()
  }
  allMenuUrl:any

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    this.authServic.identityCheck();
    /* this.allMenuUrl = menus
    console.log(menus);
    if (menus && Array.isArray(menus)) { // menus tanımlı mı ve bir dizi mi?
      const flattenMenuUrls = (menuItems: any[]): string[] => {
        let urls: string[] = [];
        menuItems.forEach(item => {
          if (item.url) {
            urls.push(item.url); // URL varsa ekle
          }
          if (item.children && Array.isArray(item.children)) { // Çocuklar tanımlı mı ve bir dizi mi?
            urls = [...urls, ...flattenMenuUrls(item.children)];
          }
        });
        return urls;
      };
    
      const allMenuUrls = flattenMenuUrls(menus);
      console.log(allMenuUrls); // Flattened URL'leri kontrol edin
      this.allMenuUrl = allMenuUrls;
    }  */
     
    if (!_isAuthenticated) {
      this.router.navigate(["pages/authentication/login-v2"], { queryParams: { returnUrl: state.url } });
      this._toastService.error("Giriş yapmadan erişilemez.", "Giriş Yap!");
      return false;
    }

    // Yetki kontrolü
    if (route.data.roles && route.data.roles.indexOf(_isRole) === -1) {
      this.router.navigate(['/pages/miscellaneous/error']);
      this._toastService.error("Yetkisiz erişim.", "Yetkiniz Yok!");
      return false;
    }

    /* const requestedUrl = state.url;
    // Menüdeki URL kontrolü
     if (!this.allMenuUrl?.includes(requestedUrl)) {
       this.router.navigate(['/pages/miscellaneous/error']);
       this._toastService.error("Böyle bir sayfa bulunamadı.", "Sayfa Hatası!");
       return false;
     }
 */
    return true;
  }

}
